import React from 'react';

interface LeftBlockProps {
  strokeColor?: string;
  fillColor?: string;
  className?: string;
  preserveAspectRatio?: string;
}

export const LeftBlock: React.FC<LeftBlockProps> = ({
  strokeColor,
  fillColor,
  className,
  preserveAspectRatio = 'none',
}) => {
  return (
    <svg
      width='804'
      height='359'
      viewBox='0 0 804 359'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      preserveAspectRatio={preserveAspectRatio}
    >
      <g clipPath='url(#clip0_126_304)'>
        <rect width='180' height='60' transform='matrix(-1 0 0 1 804 300)' stroke={strokeColor} />
        <path d='M900 240H720V300H900V240Z' fill={fillColor} stroke={strokeColor} />
        <path d='M624 300H444V360H624V300Z' fill={fillColor} stroke={strokeColor} />
        <rect width='180' height='60' transform='matrix(-1 0 0 1 624 180)' stroke={strokeColor} />
        <rect width='180' height='60' transform='matrix(-1 0 0 1 720 240)' stroke={strokeColor} />
        <rect width='180' height='60' transform='matrix(-1 0 0 1 444 300)' stroke={strokeColor} />
        <rect width='180' height='60' transform='matrix(-1 0 0 1 444 180)' stroke={strokeColor} />
        <path d='M444 60H264V120H444V60Z' fill={fillColor} stroke={strokeColor} />
        <rect width='180' height='60' transform='matrix(-1 0 0 1 540 240)' stroke={strokeColor} />
        <rect width='180' height='60' transform='matrix(-1 0 0 1 540 120)' stroke={strokeColor} />
        <rect width='180' height='60' transform='matrix(-1 0 0 1 264 300)' stroke={strokeColor} />
        <rect width='180' height='60' transform='matrix(-1 0 0 1 264 180)' stroke={strokeColor} />
        <rect width='180' height='60' transform='matrix(-1 0 0 1 264 60)' stroke={strokeColor} />
        <rect width='180' height='60' transform='matrix(-1 0 0 1 360 240)' stroke={strokeColor} />
        <rect width='180' height='60' transform='matrix(-1 0 0 1 360 120)' stroke={strokeColor} />
        <rect width='180' height='60' transform='matrix(-1 0 0 1 84 300)' stroke={strokeColor} />
        <rect width='180' height='60' transform='matrix(-1 0 0 1 84 180)' stroke={strokeColor} />
        <rect width='180' height='60' transform='matrix(-1 0 0 1 84 60)' stroke={strokeColor} />
        <rect width='180' height='60' transform='matrix(-1 0 0 1 180 240)' fill={fillColor} stroke={strokeColor} />
        <rect width='180' height='60' transform='matrix(-1 0 0 1 180 120)' stroke={strokeColor} />
        <rect width='180' height='60' transform='matrix(-1 0 0 1 180 0)' stroke={strokeColor} />
      </g>
      <defs>
        <clipPath id='clip0_126_304'>
          <rect width='804' height='359' fill='white' transform='matrix(-1 0 0 1 804 0)' />
        </clipPath>
      </defs>
    </svg>
  );
};
